import type { ActivityModule } from '../../core/activity';
import { mountGraduatedLineUse } from './ui';
import levelsData from './levels.json';
import './style.css';

export const graduatedLineUse: ActivityModule = {
  id: 'graduated_line_use',
  title: 'Use a régua',
  description: 'Coloque o número na posição certa da régua. Clique direto na graduação.',
  ageMin: 6,
  ageMax: 10,
  difficulty: 1,
  iconPath: 'assets/gcompris-AGPL/graduated_line_use/icon.svg',
  category: 'numeracao',
  totalLevels: levelsData.levels.length,
  mount: mountGraduatedLineUse,
};
